import React from 'react';
import {IndexLink, Link} from 'react-router';

var $ = require('jquery');
var items = [];
import axios from 'axios';
import Select from 'react-select';
import 'react-select/dist/react-select.css';
import Footer2Component from "./footer2";
import FooterComponent from "./footer";

var schools;
export default class Splash_ESignup extends React.Component {
    constructor(props) {
        super(props);
        //this.handleChange = this.handleChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.state = {
            comOps: [],
            user: {fname: '', lname: '', email: '', pass: '', company: 0, name_company: "", phone: "", disabled: false}
        };
    }


    componentDidMount() {
        console.log("Splash_ESignup")
    }

    handleChange(propertyName, event) {
        const user = this.state.user;
        user[propertyName] = event.target.value;
        this.setState({user: user});
    };

    handleSubmit(event) {
        event.preventDefault();
        const user = this.state.user;
        user['api'] = 'esignup';

        const email = this.state.user.email.trim();
        const pass = this.state.user.pass.trim().length;

        if (this.state.user.email.trim().length == 0 || this.state.user.pass.trim().length == 0 || this.state.user.phone.trim().length == 0 || this.state.user.fname.trim().length == 0 || this.state.user.lname.trim().length == 0 || this.state.user.disabled) {
            return;
        }
        if (this.state.user.company == 0 && this.state.user.name_company.length == 0) {
            return;
        }

        this.state.user.disabled = true;
        $.ajax({
            url: this.props.url,
            dataType: 'json',
            type: 'POST',
            data: user,
            success: function (data) {
                console.log(data);
                if (data.status == 1) {
                    // this.props.openDialog(data.message);
                    //this.props.openDialog("Your account has been created! Please check your email for verification!");
                    this.setState({
                        user: {
                            fname: '',
                            lname: '',
                            email: '',
                            pass: '',
                            company: 0,
                            name_company: "",
                            phone: "",
                            disabled: false
                        }
                    })
                    window.location.replace("/home");
                }
                else {
                    this.props.openDialog(data.message);
                    //console.log('alert here');
                }
                this.state.user.disabled = false;

            }.bind(this),
            error: function (xhr, status, err) {
                console.error(this.props.url, status, err.toString());
                this.state.user.disabled = false;
            }.bind(this)
        });
        //user[propertyName] = event.target.value;
    };

    getCompOptions(input) {
        if (input.length == 0 || input.length < 2) {


            //this.setState({location:""});
            this.setState({comOps: this.state.comOps});
        }
        else {

            var data = new FormData();

            data.append('search', input);


            axios.post('/code/apis.php?api=searchCompany', data, {
                progress: (progressEvent) => {

                }
            })
                .then(response => {
                    if (response.data.status == 1) {
                        var array = [];
                        var i = 1;
                        for (var item of response.data.data) {
                            var name = item.name_company;

                            var img = '';
                            if (item.id_file_company > 0) {
                                img = item.file.link_file;
                            }
                            var des = item.city_company;
                            array.push({value: item.id_company, label: name, des: des, icon: img});
                            i++;
                        }
                        if (array.length == 0) {
                            array.push({value: 0, label: input, des: "Add New Company", icon: ""});
                        }

                        this.setState({comOps: array});
                        //callback(null,{options:response.data.data});
                    }
                    else {
                        //callback(null,{options:[]});
                    }
                    //console.log(response.data);

                    return response;
                }).catch(error => {
                //callback(null,{options:[]});
            });

        }
        //console.log(callback);

        //return testop;
    }

    optionRenderer(option) {
        var img = option.label.substring(0, 1).toUpperCase();
        if (option.icon != "") {
            img = (<img src={option.icon}/>);
        }
        return (<div className="option_item">
            <div className="option_img">
                {img}
            </div>
            <div className="option_label">
                <span className="name">{option.label}</span><br/>
                <span className="des">{option.des}</span>
            </div>
        </div>);
    }

    onSelectCompany(item) {


        var user = this.state.user;
        if (item.value == 0) {
            user.name_company = item.label;
            user.company = 0;


        }
        else {
            user.company = item.value;
            user.name_company = "";
        }
        this.setState({user: user});

    }

    render() {
        if (this.props.isMobile == 1) {
            return (
                <form onSubmit={this.handleSubmit}>
                    <div className="account_box_wrappers">
                        <div className={"head"}>
                            <div className={"content"}>
                                <h3>Post today innovate tomorrow.</h3>
                                <small>Fueled by community, driven by innovation.</small>

                                <input
                                    className={"form-control input-lg"}
                                    onChange={this.handleChange.bind(this, 'fname')}
                                    value={this.state.user.fname}
                                    required name="n"
                                    type="text"
                                    placeholder="First Name"/>
                                <input
                                    className={"form-control input-lg second"}
                                    onChange={this.handleChange.bind(this, 'lname')}
                                    value={this.state.user.lname}
                                    required
                                    name="ln"
                                    type="text"
                                    placeholder="Last Name"/>
                            </div>
                        </div>
                        <div className={"bottom"}>
                            <div className={"content"}>
                                <div className="home-school">
                                    <Select
                                        value={this.state.user.company}
                                        onChange={this.onSelectCompany.bind(this)}
                                        placeholder="Company Name"
                                        options={this.state.comOps}
                                        optionRenderer={this.optionRenderer}
                                        noResultsText="No company found"
                                        searchPromptText="Enter at least 2 characters"
                                        onInputChange={this.getCompOptions.bind(this)}
                                        clearable={false}
                                        searchable={true}
                                        allowCreate={true}
                                        className={"esignup-select"}
                                    />
                                </div>
                                <input
                                    className={"form-control input-lg"}
                                    onChange={this.handleChange.bind(this, 'phone')}
                                    value={this.state.user.phone}
                                    required
                                    name="e"
                                    type="phone"
                                    placeholder="Phone"/>
                                <input
                                    className={"form-control input-lg"}
                                    onChange={this.handleChange.bind(this, 'email')}
                                    value={this.state.user.email}
                                    required
                                    name="e"
                                    type="email"
                                    placeholder="Work Email"/>
                                <input
                                    className={"form-control input-lg"}
                                    onChange={this.handleChange.bind(this, 'pass')}
                                    value={this.state.user.pass}
                                    required
                                    name="p"
                                    type="password"
                                    placeholder="Password"/>
                                <div className="text01">
                                    <div className="chkbox">
                                        <input type="checkbox" tabIndex="3" id="keepLogin" name="lremember"/>
                                    </div>
                                    <span className="labbox elabbox">
                                        I confirm I represent HR, Recruiting, Marketing, PR, or am an executive at my company and I agree to Versity's
                                        <Link to="/terms">Terms of Service</Link>, <Link to="/privacy">Privacy Policy</Link> and <Link to="/cookies">Cookie Policy</Link> on behalf of my company.
                                    </span>
                                </div>
                                <input
                                    className={"btn btn-lg btn-primary btn-block"}
                                    disabled={this.state.user.disabled}
                                    type="submit"
                                    value="Unlock Free Business Page"/>
                                <p>Already have an account? <Link className={"btn04"} to="/signin">Sign In!</Link></p>

                                <div className={"footerClear"}>&nbsp;</div>
                                <FooterComponent/>
                            </div>
                        </div>
                    </div>
                </form>
            )
        }
        return (
            <form onSubmit={this.handleSubmit} autoComplete="off">
                <div className="splash_esignup">
                    <h3>
                        <strong>
                            Post today innovate tomorrow.
                        </strong>
                        <br/>
                        Fueled by community, driven by innovation.
                    </h3>
                    <div className="content">
                        <div className="field_row">
                            <div className="right_field">
                                <div className="div_49_left">
                                    <input className="input_text" onChange={this.handleChange.bind(this, 'fname')}
                                           value={this.state.user.fname} required name="n" type="text"
                                           placeholder="First Name"/>
                                </div>
                                <div className="div_49_right">
                                    <input className="input_text" onChange={this.handleChange.bind(this, 'lname')}
                                           value={this.state.user.lname} required name="ln" type="text"
                                           placeholder="Last Name"/>
                                </div>
                            </div>
                        </div>
                        <div className="field_row">
                            <div className="right_field">
                                <Select

                                    value={this.state.user.company}
                                    onChange={this.onSelectCompany.bind(this)}
                                    placeholder="Company Name"
                                    options={this.state.comOps}
                                    optionRenderer={this.optionRenderer}

                                    noResultsText="No company found"
                                    searchPromptText="Enter at least 2 characters"
                                    onInputChange={this.getCompOptions.bind(this)}
                                    clearable={false}
                                    searchable={true}
                                    allowCreate={true}
                                    className={"esignup-select"}
                                />
                            </div>
                        </div>
                        <div className="field_row">
                            <div className="right_field">
                                <input className="input_text" onChange={this.handleChange.bind(this, 'phone')}
                                       value={this.state.user.phone} required name="e" type="phone"
                                       placeholder="Phone"/>
                            </div>
                        </div>
                        <div className="field_row">
                            <div className="right_field">
                                <input className="input_text" onChange={this.handleChange.bind(this, 'email')}
                                       value={this.state.user.email} required name="e" type="email"
                                       placeholder="Work Email"/>
                            </div>
                        </div>
                        <div className="field_row">
                            <div className="right_field">
                                <input className="input_text" onChange={this.handleChange.bind(this, 'pass')}
                                       value={this.state.user.pass} required name="p" type="password"
                                       placeholder="Password"/>
                            </div>
                        </div>

                    </div>
                    <div className="text01">
                        <div className="chkbox">
                            <input type="checkbox" tabIndex="3" id="keepLogin" name="lremember"/>
                        </div>
                        <span className="labbox">
                            I confirm I represent HR, Recruiting, Marketing, PR, or am an executive at my
                            company and I agree to Versity's <Link to="/terms">Term of Service</Link> and <Link
                            to="/privacy">Privacy Policy</Link> on behalf of my company.
                        </span>
                    </div>


                    <div className="content">
                        <div className="field_row">
                            <div className="row">
                                <input className="btn_v btn_confirm" disabled={this.state.user.disabled} type="submit"
                                       value="Unlock Free Business Page"/>
                            </div>
                            <div className="row">
                                <p className="text02">Already have an account? <Link to="/signin">Sign In!</Link></p>
                            </div>
                        </div>
                    </div>
                </div>
            </form>

        )
    }
};



/** WEBPACK FOOTER **
 ** ./src/client/app/homecomponents/commons/splash_esignup.js
 **/